import { ComponentType } from 'react'
import AuthPage from './AuthPage'
import BanPage from './BanPage'
import DashboardPage from './DashboardPage'
import DevicesPage from './DevicesPage'
import GoogleAuthPage from './GoogleAuthPage'
import LoginPage from './LoginPage'
import MissionDetailPage from './MissionDetailPage'
import MissionDetailWebviewPage from './MissionDetailWebviewPage'
import MissionsPage from './MissionsPage'
import MissionsWebviewPage from './MissionsWebviewPage'
import NectarTaskPage from './NectarTaskPage'
import NectarTaskWebviewPage from './NectarTaskWebviewPage'
import ProfilePage from './ProfilePage'
import ProfileWebviewPage from './ProfileWebviewPage'
import ReferralsPage from './ReferralsPage'
import RestrictedDataPage from './RestrictedDataPage'
import StakeSOLPage from './StakeSOLPage'

/* const RestrictedDataPage = lazy(() => import('./RestrictedDataPage'))
const DashboardPage = lazy(() => import('./DashboardPage.tsx'))
const DevicesPage = lazy(() => import('./DevicesPage.tsx'))
const LoginPage = lazy(() => import('./LoginPage.tsx'))
const PolicyPage = lazy(() => import('./PolicyPage.tsx'))
const ReferralsPage = lazy(() => import('./ReferralsPage.tsx'))
const TermsPage = lazy(() => import('./TermsPage.tsx')) */

export type Route = {
  path: string
  Component: ComponentType
  isPublic?: boolean
  noMenu?: boolean
  isWebview?: boolean
}

export const routes: Record<string, Route> = {
  login: { path: '/login', Component: LoginPage, isPublic: true },
  auth: { path: '/auth', Component: AuthPage, isPublic: true },
  googleAuth: { path: '/auth/google', Component: GoogleAuthPage, isPublic: true },
  ban: { path: '/banned', Component: BanPage, isPublic: true },

  dashboard: { path: '/', Component: DashboardPage },
  devices: { path: '/devices', Component: DevicesPage },
  referrals: { path: '/referrals', Component: ReferralsPage },
  authData: { path: '/restricted-data', Component: RestrictedDataPage },
  missions: { path: '/missions', Component: MissionsPage },
  mission: { path: '/missions/:id', Component: MissionDetailPage },
  nectarTasks: { path: '/missions/nectar/:projectId/tasks', Component: NectarTaskPage },
  stake: { path: '/stake', Component: StakeSOLPage },
  profile: { path: '/profile', Component: ProfilePage },

  profileWebview: { path: '/profile/webview', Component: ProfileWebviewPage, isWebview: true },
  missionsWebview: { path: '/missions/webview', Component: MissionsWebviewPage, isWebview: true },
  missionWebview: { path: '/missions/webview/:id', Component: MissionDetailWebviewPage, isWebview: true },
  nectarTasksWebview: {
    path: '/missions/webview/nectar/:projectId/tasks',
    Component: NectarTaskWebviewPage,
    isWebview: true
  }
}

export type RouteKey = keyof typeof routes

export const nectarPaths = {
  tasks: (projectId: string, basePath: string = '/missions') => `${basePath}/nectar/${projectId}/tasks`
}
